import { Component } from '@angular/core';
import { AlertController,App} from 'ionic-angular';
import { StorageService } from '../../../../providers/service/storageservice';
import { LoginPage } from '../../../login/login/login';
import { AppState } from '../../../../app/app.global';

import { HttpService } from '../../../../providers/service/httpservice';
import { CHECK_BIND_MAIL, SEND_EMAIL_CODE, SAVE_BIND_MAIL } from '../../../../providers/config/serviceurl';
import { Utils} from '../../../../providers/service/utils';
import { ToastAlert } from '../../../../providers/util/toastalert';
import { TabsPage } from '../../../tabs/tabs/tabs';
import { HomePage } from '../../../home/home/home';

@Component({
  selector: 'bind-email-page',
  templateUrl: 'bindEmail.html'
})
export class BindEmailPage {
	user:any =null;
	emailNo: '';
	emailCode: '';
	codemsg:string='获取验证码';
	codetime:number= 60;
	status:boolean= false;
	constructor (private alertCtrl: AlertController,public appCtrl: App,public global: AppState,
		private httpService:HttpService,public toastAlert: ToastAlert) {
		this.user = StorageService.getObj('currentUser');
	}
	saveBindEmail(){
		if(!this.emailNo){
			let alert = this.alertCtrl.create({
				message: '请填写邮箱号',
				buttons: ['确定']
			});
			alert.present();
			return false;
		}
		if(!this.emailCode){
			let alert = this.alertCtrl.create({
				message: '请填写验证码',
				buttons: ['确定']
			});
			alert.present();
			return false;
		} 
		let params = { accountKey: Utils.base64Encode(this.user.username), emailinfo: Utils.base64Encode(this.emailNo), emailcode: Utils.base64Encode(this.emailCode) };
		this.httpService.get2(SAVE_BIND_MAIL, params).then(anyObj =>this.handleSaveBindEmail(anyObj));
	}
	sendEmailCode(){
		if (!this.emailNo) {
			let alert = this.alertCtrl.create({
				message: '请输入邮箱号',
				buttons: ['确定']
			});
			alert.present();
			return false;
		}
		if(!this.status){
			this.settime();
			let params = { accountKey: Utils.base64Encode(this.user.username), emailinfo: Utils.base64Encode(this.emailNo) };
			this.httpService.get2(SEND_EMAIL_CODE, params).then(obj => this.handleSendEmailCode(obj));
		}
	}
	handleSendEmailCode(obj) {
		// console.log('++++ sendResult ++++ '+ obj.error.message)
        if(obj){
			if(obj.error) {
				let alert = this.alertCtrl.create({
					message: '绑定邮箱失败！',
					buttons: ['确定']
				});
				alert.present();
			} else {
				this.toastAlert.alertMsg(obj.data.message, 'middle', 3000);
				// setTimeout(() => {
				// 	this.appCtrl.getRootNav().setRoot(HomePage);
				// }, 2000);
			} 
		}
	}
	settime() {
      if(this.codetime == 1){
		  this.codetime = 60;
		  this.codemsg = "获取验证码";
		  this.status = false;
		  return;
	  } else {
		this.status = true;
		this.codetime--;
	  }
      this.codemsg = "重新获取(" + this.codetime + ")";
        setTimeout(() => {
			this.codemsg = "重新获取(" + this.codetime + ")";
			this.settime();
        }, 1000);
    }
	handleSaveBindEmail(obj:any){
		console.log('data === ' + JSON.stringify(obj));
		if(obj && obj.data){
			if( obj.data.code === '1'){
				let alert = this.alertCtrl.create({
				message: obj.data.message,
				buttons: [
				 {		 
					 text:'确定',
					 handler:() =>{
						this.appCtrl.getRootNav().setRoot(TabsPage);
					 }
				  }
				 ]
			  	});
				alert.present();
			}else{
				this.toastAlert.alertMsg(obj.data.message, 'middle', 3000); 
			}
		}
		
	}
}



// WEBPACK FOOTER //
// ./src/pages/login/email/bind/bindEmail.ts